<script setup lang="ts">
import { Info } from 'lucide-vue-next'
import type { ContentScopeSubject } from '@/types/contentScope'

defineProps<{
  subject: ContentScopeSubject
}>()

const { t } = useI18n()
</script>

<template>
  <AppTooltip width="max-w-xs">
    <span class="inline-flex items-center gap-1.5" tabindex="0" data-testid="content-scope-column-header">
      {{ t('contentScope.origin') }}
      <Info class="size-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
    </span>
    <template #tooltip-content>
      <span class="flex flex-col gap-2 text-left">
        <span>
          <span class="block font-semibold">{{ t('contentScope.scopes.network') }}</span>
          {{ t(`contentScope.subjects.${subject}.networkDescription`) }}
        </span>
        <span>
          <span class="block font-semibold">{{ t('contentScope.scopes.local') }}</span>
          {{ t(`contentScope.subjects.${subject}.localDescription`) }}
        </span>
        <span class="opacity-80">{{ t(`contentScope.subjects.${subject}.description`) }}</span>
      </span>
    </template>
  </AppTooltip>
</template>
